import React, { useState, useContext } from 'react';
import AppContext from '../../context/AppContext';

// Version simplifiée pour résoudre l'erreur "Illegal constructor"
const CustomPaymentConfig = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { setShowPaymentConfig, setShowPaymentSheet } = useContext(AppContext);

  const handleClose = () => {
    setIsOpen(false);
    setShowPaymentConfig(false);
  };

  const handleShowPaymentSheet = () => {
    setShowPaymentSheet(true);
    setShowPaymentConfig(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md animate-slide-up mx-4">
        <h2 className="text-xl font-semibold mb-4">Configuration des paiements</h2>
        
        <p className="text-gray-600 mb-6">
          Pour accepter des paiements, vous devez configurer au moins une méthode de paiement.
          Cela vous permettra de recevoir des paiements de vos clients.
        </p>
        
        <div className="bg-blue-50 p-4 rounded-lg mb-6">
          <p className="text-sm text-blue-700">
            🔒 Vos informations de paiement sont sécurisées et cryptées
          </p>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={handleShowPaymentSheet}
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium"
          >
            Configurer maintenant
          </button>
          
          <button
            onClick={handleClose}
            className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-medium"
          >
            Plus tard
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomPaymentConfig;